import useEventBarFastFollows from '@/components/global/layout/AppBar/hooks/useEventBarFastFollows';
import {useStoreNextRouter} from '@/components/global/providers/StoreNextRouter';
import {useEventBarV2} from '../EventBarV2Provider';
import {
  type AdvanceDecision,
  decideAdvance,
  deriveProvidedFields,
  type ProvidedFields,
} from '../utils/askFlow';
import {type EventBarField} from '../utils/fields';

type EventBarAskFlow = {
  decideAdvanceFrom: (from: EventBarField) => AdvanceDecision;
  providedFields: ProvidedFields;
};

// With the flag off, nothing counts as settled, so the bar walks every field in order.
const NOTHING_PROVIDED: ProvidedFields = {where: false, when: false, who: false};

// Which fields the bar still needs to ask about, and where it goes when a panel is done. The one
// place the menu-page/search-page split is consulted for advance purposes.
export const useEventBarAskFlow = (): EventBarAskFlow => {
  const {engagedFields, headCount, whenDate, whereSelection} = useEventBarV2();
  const {isOnMenuPage} = useStoreNextRouter();
  const {showEventBarFastFollows} = useEventBarFastFollows();

  const providedFields = showEventBarFastFollows
    ? deriveProvidedFields({
        engagedFields,
        hasWhereSelection: whereSelection !== null,
        headCount,
        whenDate,
      })
    : NOTHING_PROVIDED;

  const decideAdvanceFrom = (from: EventBarField) =>
    decideAdvance(from, providedFields, isOnMenuPage);

  return {decideAdvanceFrom, providedFields};
};
